import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Stepper = ({ currentStep, totalSteps }) => {
  const { t } = useLanguage();
  
  const steps = [
    { number: 1, label: t('step1') },
    { number: 2, label: t('step2') },
    { number: 3, label: t('step3') },
    { number: 4, label: t('step4') },
    { number: 5, label: t('step5') },
    { number: 6, label: t('step6') },
    { number: 7, label: t('step7') }
  ];

  return (
    <div className="flex items-center justify-between w-full max-w-2xl mx-auto mb-8" data-testid="stepper">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className="flex flex-col items-center gap-2">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${
                currentStep > step.number
                  ? 'bg-blue-600 text-white ring-4 ring-blue-100'
                  : currentStep === step.number
                  ? 'bg-blue-600 text-white ring-4 ring-blue-100'
                  : 'bg-slate-100 text-slate-400'
              }`}
              data-testid={`step-${step.number}`}
            >
              {currentStep > step.number ? (
                <Check className="w-5 h-5" />
              ) : (
                <span>{step.number}</span>
              )}
            </div>
            <span
              className={`text-xs font-medium hidden sm:block ${
                currentStep >= step.number ? 'text-blue-600' : 'text-slate-400'
              }`}
            >
              {step.label}
            </span>
          </div>
          
          {index < steps.length - 1 && (
            <div
              className={`flex-1 h-0.5 mx-2 transition-colors ${
                currentStep > step.number ? 'bg-blue-600' : 'bg-slate-200'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Stepper;